import { FC } from 'react';
import Testimonial from './Testimonial';

interface RightSideFeaturesProps {}

const RightSideFeatures: FC<RightSideFeaturesProps> = () => {
  return (
    <div className="min-h-screen hidden md:block bg-gray-50 border-l custom-border-color">
      <nav className="h-[70px] sticky bg-gray-50 z-10 top-0 w-full px-6 flex items-center justify-between">
        <span></span>
      </nav>
      <div className="min-h-[calc(100vh-70px)] flex flex-col justify-center">
        <div className="w-full mx-auto relative px-12 flex flex-col">
          <h2 className="text-2xl font-semibold text-[#5E6AB2] mb-6">
            If you're not answering your customer's call, your competition is...
          </h2>
          
          <div className="flex gap-8">
            <div className="grid grid-cols-1 gap-3 flex-1">
              <div className="flex items-center gap-2">
                <img src="/images/nucleus-headset-icon.svg" alt="AI Receptionist" className="w-6 h-6" />
                <span className="text-sm">24/7 AI Receptionist</span>
              </div>
              
              <div className="flex items-center gap-2">
                <img src="/images/call-transfer.svg" alt="Call Transfer" className="w-6 h-6" />
                <span className="text-sm">Transfers Calls, Takes Messages</span>
              </div>
              
              <div className="flex items-center gap-2">
                <img src="/images/real-time-reporting.svg" alt="Call Reporting" className="w-6 h-6" />
                <span className="text-sm">Real-Time Call Reporting</span>
              </div>
              
              <div className="flex items-center gap-2">
                <img src="/images/customizable-greetings.svg" alt="Customizable Greetings" className="w-6 h-6" />
                <span className="text-sm">Customizable Greetings</span>
              </div>
              
              <div className="flex items-center gap-2">
                <img src="/images/free-business-number.svg" alt="Phone Number" className="w-6 h-6" />
                <span className="text-sm">Free Local Business Phone Number</span>
              </div>
              
              <div className="flex items-center gap-2">
                <img src="/images/conversational-ai.svg" alt="Conversational AI" className="w-6 h-6" />
                <span className="text-sm">Conversational AI to Engage Callers</span>
              </div>
              
              <div className="flex items-center gap-2">
                <img src="/images/no-credit-card.svg" alt="No Credit Card" className="w-6 h-6" />
                <span className="text-sm">No Credit Card Required</span>
              </div>
            </div>
            
            <div className="flex-1 flex items-center justify-center">
              <img 
                src="/images/nucleus-collage.png" 
                alt="Nucleus AI Features" 
                className="w-full max-w-[250px] h-auto"
              />
            </div>
          </div>
          
          <div className="mt-8">
            <Testimonial />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightSideFeatures; 